import { jsx as e } from "react/jsx-runtime";
import { tv as o } from "tailwind-variants";
const t = o({
  base: ["border-b", "border-inherit", "px-5", "py-3"]
}), i = ({ children: r, className: s }) => /* @__PURE__ */ e("div", { className: t({ class: s }), children: r });
export {
  i as default
};
